import { render } from "./MakeDirectory.vue?vue&type=template&id=834f15d6"
import script from "./MakeDirectory.vue?vue&type=script&lang=js"
export * from "./MakeDirectory.vue?vue&type=script&lang=js"

import "./MakeDirectory.vue?vue&type=style&index=0&id=834f15d6&lang=postcss"

import exportComponent from "/var/vhosts/unrisd-frontend/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__